import { stateSchema } from "@redotech/redo-model/geographic-unit";
import * as z from "zod";

export const getStates = {
  name: "getStates" as const,
  input: z.object({ countryCode: z.string() }),
  output: z.array(stateSchema),
};
